import { api } from './client.js';

/** The current user's own organization — safe for any authenticated user, not admin-only. */
export const orgApi = {
  getMine: () => api.get('/api/org'),
};
